import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { getLangData, createLink, getCurrentLangCode } from "../services/lang";
import logo from '../img/logo_signature.png';

class Nav extends Component<{}, NavState> {

    constructor(props: Readonly<{}>) {
        super(props);

        this.state = { currentLang: getCurrentLangCode() };

        this.changeLang = this.changeLang.bind(this);
    }

    changeLang(langCode: string) {
        const { currentLang } = this.state;
        if (langCode === currentLang) return;

        const currentPathSegments = window.location.pathname.split('/');
        currentPathSegments[1] = langCode;

        const newPath = currentPathSegments.join('/');
        window.location.pathname = newPath;
    }

    render() {

        const { currentLang } = this.state;
        const langData = getLangData();

        return (
            <header className="container-fluid sticky-top px-0 mb-5 border-bottom bg-white">
                <div className="container">
                    <nav className="navbar navbar-expand-lg p-0 d-flex justify-content-end text-right">
                        <Link className="navbar-brand text-uppercase lead" to={createLink("/estate")}>
                            <img src={logo} className="d-inline-block align-top nav-logo my-2" alt="logo"></img>
                        </Link>
                        <button className="navbar-toggler text-uppercase" type="button"
                            data-toggle="collapse" data-target="#navbarSupportedContent">
                            {langData.meta.menu}
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav ml-auto">
                                <li className="nav-item ml-2">
                                    <Link className="nav-link" to={createLink("/estate")}>{langData.estate.header}</Link>
                                </li>
                                <li className="nav-item ml-2">
                                    <Link className="nav-link" to={{ pathname: createLink("/catalogue"), state: "desiredState" }}>{langData.catalogue.header}</Link>
                                </li>
                                <li className="nav-item ml-2">
                                    <Link className="nav-link" to={createLink("/biography")}>{langData.biography.header}</Link>
                                </li>
                                <li className="nav-item ml-2">
                                    <Link className="nav-link" to={createLink("/news")}>{langData.news.header}</Link>
                                </li>
                                <li className="nav-item ml-2">
                                    <Link className="nav-link" to={createLink("/contact")}>{langData.contact.header}</Link>
                                </li>
                                <li className="nav-item ml-2 dropdown">
                                    <button className="nav-link btn btn-link dropdown-toggle" data-toggle="dropdown">
                                        {currentLang.toUpperCase()}
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-md-right">
                                        <button className="dropdown-item" onClick={() => this.changeLang('en')}>EN</button>
                                        <button className="dropdown-item" onClick={() => this.changeLang('de')}>DE</button>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </header>
        );
    }
}

type NavState = {
    currentLang: string;
};

export default Nav;